import { theme } from 'lib/theme';
import React from 'react';
import {
  GestureResponderEvent,
  ImageStyle,
  StyleProp,
  View,
  ViewStyle,
} from 'react-native';

import { Icon, ICONS } from './Icon';
import { Pressable, PressableProps } from './Pressable';

const ICON_BUTTON_HEIGHT = 20;

export type IconButtonProps = {
  onPress?: (event: GestureResponderEvent) => void;
  onPressIn?: (event: GestureResponderEvent) => void;
  onPressOut?: (event: GestureResponderEvent) => void;
  icon: ICONS;
  iconSize?: number;
  style?: StyleProp<ViewStyle>;
  color?: string;
  disabled?: boolean;
  imageStyle?: StyleProp<ImageStyle>;
  active?: boolean;
  size?: number;
  marginHorizontal?: boolean;
  borderRadius?: number;
  hoverColor?: string;
  pressedStyle?: StyleProp<ViewStyle>;
  hoveredStyle?: StyleProp<ViewStyle>;
  pressedColor?: string;
  showBadge?: boolean;
  accessibilityLabel?: PressableProps['accessibilityLabel'];
  accessibilityHint?: PressableProps['accessibilityHint'];
};

export const IconButton: React.FC<IconButtonProps> = ({
  active,
  color,
  disabled,
  icon,
  iconSize,
  imageStyle,
  marginHorizontal = false,
  onPress,
  onPressIn,
  onPressOut,
  hoverColor,
  pressedColor,
  pressedStyle,
  hoveredStyle,
  size,
  style,
  borderRadius,
  showBadge,
  accessibilityLabel,
  accessibilityHint,
}) => {
  const finalSize = size || ICON_BUTTON_HEIGHT + theme.grid;

  return (
    <Pressable
      disabled={disabled}
      style={[
        {
          alignItems: 'center',
          backgroundColor: active ? theme.colors.blue20 : undefined,
          justifyContent: 'center',
          marginRight: marginHorizontal ? theme.buttonMargin * 2 : 0,
          marginLeft: marginHorizontal ? theme.buttonMargin * 2 : 0,
          padding: theme.grid,
          width: finalSize,
          height: finalSize,
          borderRadius: borderRadius || finalSize,
        },
        style,
      ]}
      hoveredStyle={[
        { backgroundColor: hoverColor || theme.colors.blue10 },
        hoveredStyle,
      ]}
      pressedStyle={[
        { backgroundColor: pressedColor || theme.colors.blue20 },
        pressedStyle,
      ]}
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      accessibilityLabel={accessibilityLabel}
      accessibilityHint={accessibilityHint}
    >
      <Icon
        source={icon}
        size={iconSize || 19}
        color={color || theme.colors.blue}
        style={imageStyle}
      />
      {showBadge && (
        <View
          style={{
            position: 'absolute',
            right: 2,
            bottom: 2,
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: theme.colors.orange,
            zIndex: 1,
            elevation: 1,
          }}
        />
      )}
    </Pressable>
  );
};
